// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","body":"Footer_body__emm9z","rightCol":"Footer_rightCol__zPASv","socialButton":"Footer_socialButton__4Coz4","contact":"Footer_contact__wFbzr"};